import { Link } from './link.component';

export * from './link.component';
export default Link;

Link.define('der-ui-link');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-link': Link;
    }
}
